export default "__VITE_ASSET__DZITsNBR__"